import React from 'react';
import T from 'prop-types';
import { Input, Form } from 'antd';

import { MODAL_PASSWORD_RESET } from '../../../../constants/app';

import ErrorAlert from '../../../errorAlert';
import Modal from '../../../modal';
import FormItem from '../../../formItem';

import { config } from './config';

const failMessage = 'Error resetting password.';

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 7 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 17 },
  },
};

const PasswordResetModal = ({ error, errorMessage, isLoading, resetPassword }) => {
  const handleOnFinish = ({ password }) => {
    resetPassword(password);
  };

  return (
    <Modal
      name={MODAL_PASSWORD_RESET}
      okButtonProps={{ htmlType: 'submit', form: MODAL_PASSWORD_RESET, loading: isLoading }}
      okText="Reset Password"
      title="Reset Password"
    >
      <ErrorAlert message={`${failMessage} ${errorMessage}`} visible={error} />
      <Form name={MODAL_PASSWORD_RESET} onFinish={handleOnFinish} {...formItemLayout}>
        <FormItem label="New Password" name="password" {...config.password}>
          <Input.Password />
        </FormItem>
        <FormItem dependencies={['password']} label="Confirm Password" name="confirm" {...config.confirm}>
          <Input.Password />
        </FormItem>
      </Form>
    </Modal>
  );
};

PasswordResetModal.propTypes = {
  resetPassword: T.func.isRequired,

  error: T.bool.isRequired,
  errorMessage: T.string.isRequired,
  isLoading: T.bool.isRequired,
};

export default PasswordResetModal;
